export default class PropertyAPIs {
  constructor(_api) {
    this.api = _api;
  }

  getSuggestions = (query) => {
    return this.api.get(`/v1/suggestions?query=${query}`);
  };

  getProperties = ({ target, filter, options }) => {
    return this.api.post("/v1/search", { target, filter, options });
  };

  getPropertyDetails = (propertyId) => {
    return this.api.get(`/v1/property?propertyId=${propertyId}`);
  };

  getNearbyComparables = (propertyId) => {
    return this.api.post(`/v1/comparables`, { target: { propertyId } });
  };

  /**
   * Search for similar properties using the search API
   * Uses FIPS code of the current property to find both on-market and off-market properties
   * 
   * @param {Object} property - The current property object
   * @param {Object} options - Search options (limit, offset)
   * @returns {Promise<Object>} Search results with properties array
   */
  searchSimilarProperties = (property, options = {}) => {
    const { limit = 50, offset = 0 } = options;

    // Build target using FIPS code (primary) or county+state (fallback)
    const target = {};
    if (property.zip) {
      target.zip = property.zip;
    } else if (property.county && property.state) {
      target.county = property.county;
      target.state = property.state;
    } else if (property.zip) {
      target.zip = property.zip;
    }

    // Build filter for similar properties
    const filter = {};

    // // Property type filter
    // if (property.propertyType) {
    //   filter.propertyType = [property.propertyType];
    // }

    // // Bedrooms range: +/- 1
    // if (property.bedrooms) {
    //   filter.bedroomsMin = Math.max(1, property.bedrooms - 1);
    //   filter.bedroomsMax = property.bedrooms + 1;
    // }

    // // Bathrooms range: +/- 1
    // if (property.bathrooms) {
    //   filter.bathroomsMin = Math.max(1, Math.floor(property.bathrooms - 1));
    //   filter.bathroomsMax = Math.ceil(property.bathrooms + 1);
    // }

    // // Square feet range: +/- 25%
    // const sqft = property.squareFeet || property.buildingSquareFeet;
    // if (sqft && sqft > 0) {
    //   filter.squareFeetMin = Math.round(sqft * 0.75);
    //   filter.squareFeetMax = Math.round(sqft * 1.25);
    // }

    // // Year built range: +/- 10 years
    // if (property.yearBuilt) {
    //   filter.yearBuiltMin = property.yearBuilt - 10;
    //   filter.yearBuiltMax = property.yearBuilt + 10;
    // }

    return this.api.post("/v1/search", {
      target,
      filter,
      options: { limit, offset },
    });
  };
}
